/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HistoricalIssuesComparisonQueryVariables = GraphQL.Exact<{
  scope: GraphQL.Scalars['String']['input'];
  since: GraphQL.Scalars['DateYMD']['input'];
  until: GraphQL.Scalars['DateYMD']['input'];
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type HistoricalIssuesComparisonQuery = { readonly __typename?: 'Query', readonly website: { readonly __typename?: 'Website', readonly id: CK.WebsiteId, readonly historicalIssuesComparison: { readonly __typename?: 'WebsiteHistoricalIssuesComparison', readonly scope: string, readonly issues: Record<string, any> } | null } | null };


export const HistoricalIssuesComparisonDocument = gql`
    query HistoricalIssuesComparison($scope: String!, $since: DateYMD!, $until: DateYMD!, $websiteId: WebsiteId!) {
  website(id: $websiteId) {
    id
    historicalIssuesComparison(scope: $scope, since: $since, until: $until) {
      scope
      issues
    }
  }
}
    `;

/**
 * __useHistoricalIssuesComparisonQuery__
 *
 * To run a query within a React component, call `useHistoricalIssuesComparisonQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricalIssuesComparisonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricalIssuesComparisonQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      since: // value for 'since'
 *      until: // value for 'until'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useHistoricalIssuesComparisonQuery(baseOptions: Apollo.QueryHookOptions<HistoricalIssuesComparisonQuery, HistoricalIssuesComparisonQueryVariables> & ({ variables: HistoricalIssuesComparisonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HistoricalIssuesComparisonQuery, HistoricalIssuesComparisonQueryVariables>(HistoricalIssuesComparisonDocument, options);
      }
export function useHistoricalIssuesComparisonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HistoricalIssuesComparisonQuery, HistoricalIssuesComparisonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HistoricalIssuesComparisonQuery, HistoricalIssuesComparisonQueryVariables>(HistoricalIssuesComparisonDocument, options);
        }
export function useHistoricalIssuesComparisonSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HistoricalIssuesComparisonQuery, HistoricalIssuesComparisonQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HistoricalIssuesComparisonQuery, HistoricalIssuesComparisonQueryVariables>(HistoricalIssuesComparisonDocument, options);
        }
export type HistoricalIssuesComparisonQueryHookResult = ReturnType<typeof useHistoricalIssuesComparisonQuery>;
export type HistoricalIssuesComparisonLazyQueryHookResult = ReturnType<typeof useHistoricalIssuesComparisonLazyQuery>;
export type HistoricalIssuesComparisonSuspenseQueryHookResult = ReturnType<typeof useHistoricalIssuesComparisonSuspenseQuery>;
export type HistoricalIssuesComparisonQueryResult = Apollo.QueryResult<HistoricalIssuesComparisonQuery, HistoricalIssuesComparisonQueryVariables>;